<template>
    <Head v-if="!loading" :title="__('Test Case')" />
    <div class="task__details">
        <div class="wrapper" id="modal">
            <div role="alert" class="container">
                <div v-if="loading" class="content">
                    <div role="status" class="td__loader">
                        <div class="__f"><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-else>
                    <div class="content">
                        
                        <div class="close_area">
                            <div class="wrap">
                                <span @click="$emit('closeModal', true)" class="close__b">
                                    <icon class="h-6 w-6" name="close" />
                                </span>
                            </div>
                        </div>
                      
                        <div class="m__body">
                            <main class="main overflow-y-auto h-full">
                                <div class="flex justify-between mt-4">
                                    <div class="rounded-md border border-gray-300 hover:shadow">
                                                <p class="px-3 p-[5px] text-sm">
                                                    {{ __('Revision') }} : {{ test_case.revision }}
                                                </p>
                                            </div>
                                    <div class="flex gap-2" v-if="role.slug === 'admin' || role.access.testcase.execute">
                                        <button v-if="start=='not_started'" class="bg-indigo-600 text-white p-[5px] rounded disabled:opacity-50 text-sm" @click="execute('start')" :disabled="test_case.status == 0">
                                            <div class="flex gap-2 items-center">
                                                <icon name="play" class="w-4 fill-[#ffffff] h-4" />
                                                <span>{{ __('Start') }}</span>
                                            </div>
                                        </button>
                                        <div v-else-if="start=='completed'" class="flex gap-2 items-center">
                                            <button 
                                                class="text-white p-[5px] rounded disabled:opacity-50 text-sm"
                                                :class="{
                                                    'bg-green-500': test_case.execution_status === 'PASS',
                                                    'bg-red-500': test_case.execution_status === 'FAIL',
                                                    'bg-orange-500': test_case.execution_status === 'WIP',
                                                    'bg-gray-500': !['PASS', 'FAIL', 'WIP'].includes(test_case.execution_status),
                                                }" disabled> {{ test_case.execution_status }}</button>
                                                <button v-if="test_case.execution_status !== 'PASS'" @click="retakeExecution()" class="bg-indigo-600 text-white p-[5px] rounded disabled:opacity-50 text-sm"> RETAKE</button>
                                        </div>
                                       
                                        <button v-else class="bg-gray-600 text-white p-[5px] rounded disabled:opacity-50 text-sm" @click="execute('stop')">{{ __('Stop') }}</button>
                                        <button class="bg-indigo-600 text-white p-[5px] rounded disabled:opacity-50 text-sm">{{ timer }}</button>
                                    </div>
                                </div>
                                
                                <div class="flex flex-col task__table">
                                    <div class="inline-block min-w-full h-full py-4 align-middle">
                                        <div class="table__view">
                                            <table>
                                                <thead>
                                                <tr>
                                                    <th scope="col" class="w-[20%]]">
                                                        {{ __('Steps') }}
                                                    </th>
                                                    <th scope="col" class="w-[10%]">
                                                        {{ __('Test Data') }}
                                                    </th>
                                                    <th scope="col" class="w-[25%]">
                                                        {{ __('Expected Result') }}
                                                    </th>
                                                    <th scope="col" class="w-[25%]">
                                                        {{ __('Actual Result') }}
                                                    </th>
                                                    <th scope="col" class="w-[10%]">
                                                        {{ __('Executed Date') }}
                                                    </th>
                                                    <th scope="col" class="w-[10%]">
                                                        {{ __('Status') }}
                                                    </th>
                                                </tr>
                                                </thead>                                                
                                                <tbody>
                                                    <tr class="list-group-item group" v-for ="(element, index) in testScripts" :key="element.id">                                                   
                                                    <td 
                                                        class="px-2 py-2 text-sm font-medium whitespace-nowrap w-[calc(32%-70px)] hover:bg-gray-100 border-l-4"
                                                        :class="{
                                                            'border-green-500': element.status_label === 'PASS',
                                                            'border-red-500': element.status_label === 'FAIL',
                                                            'border-orange-500': element.status_label === 'WIP',
                                                            'border-gray-500': !['PASS', 'FAIL', 'WIP'].includes(element.status_label),
                                                        }">
                                                        <div class="cursor-pointer" :data-id="element.id" v-html="element.step"></div> 
                                                    </td>
                                                    <td class="px-2 hide_arrow py-2 text-sm font-medium whitespace-nowrap w-[17%] cursor-pointer hover:bg-gray-100">
                                                        <div class="inline t__title text-sm font-normal rounded-full text-emerald-500 gap-x-2 bg-emerald-100/60 dark:bg-gray-800" v-html="element.test_data">
                                                        </div>
                                                    </td>
                                                    <td class="px-1 py-1 hide_arrow t_label text-sm whitespace-nowrap w-[17%] cursor-pointer hover:bg-gray-100">
                                                        <div class="inline t__title text-sm font-normal rounded-full text-emerald-500 gap-x-2 bg-emerald-100/60 dark:bg-gray-800" v-html="element.expected_result">
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="editIndex !== index" class="prose text-sm cursor-pointer" @click="toggleEditor('actual_result', index, element)" v-html="element?.executions[0]?.actual_result || 'Click to type the actual result'"></div>
                                                        <section class="mt-4" v-if="editIndex === index">
                                                            <quill-editor :ref="'actualResult-'+index" @ready="onEditorReady" v-model:content="actualResultData[index]" class="task__description" :options="editorOptions" contentType="html" theme="snow" />
                                                            <div class="mt-2">
                                                                <button type="button" class="inline-flex items-center rounded border border-gray-300 bg-indigo-600 text-white px-2.5 py-1.5 text-xs font-medium shadow-sm hover:bg-gray-50 hover:text-dark focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" @click="saveActualResult(index);editIndex = null">{{ __('Save') }}</button>
                                                                <button @click="editIndex = null" type="button" class="inline-flex items-center rounded border border-transparent hover:border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-0 ltr:ml-1 rtl:mr-1">{{ __('Cancel') }}</button>
                                                            </div>
                                                        </section>
                                                    </td>
                                                    <td>
                                                        {{ element.executions[0]?.created_at ? moment(element.executions[0].created_at).format('MMM D, h:mm A') :  'NOT EXECUTED' }}
                                                    </td>
                                                    <td class="px-2 py-2 text-sm whitespace-nowrap w-[50px] relative">
                                                       <select class="form-select" v-model="element.status_label" @change="updateStatus(element, index)" :disabled="role.slug !== 'admin' || !role.access.testcase.execute">
                                                            <option>No Action</option>
                                                            <option value="PASS">PASS</option>
                                                            <option value="FAIL">FAIL</option>
                                                            <option value="WIP">WIP</option>
                                                            <option value="SKIP">SKIP</option>
                                                            <option value="BLOCKED">BLOCKED</option>
                                                       </select>
                                                    </td>
                                                </tr>
                                                <tr v-if="!testScripts.length">
                                                    <td class="border-t px-6 py-4 text-center" colspan="7">{{ __('No steps found!') }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <delete-confirmation v-if="deleteData.confirm" @popup="closeConfirm()" @confirm="deleteStep()"
    details="Are you sure want to delete this step?" />
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Loader from '@/Shared/Loader'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axios from 'axios'
import moment from 'moment'
import draggable from 'vuedraggable'
import DeleteConfirmation from "@/Shared/DeleteConfirmation";
import { start } from '@popperjs/core';

export default {
    props: {
        project: Object,
        test_case: Object
    },
    emits: {closeModal: null, getTestCase: null},
    data() {
        return {
            start: 'not_started',
            loading: false,
            editIndex: null,
            testScripts: [],
            timer: '00:00:00',
            timerInterval: null,
            actualResultData: [],
            status: [],
            role: this.$page.props.auth.user.role,
            deleteData: {
                id: null,
                index: null,
                confirm: false
            },
            step: {
                step: '',
                test_data: '',
                expected_result: '',
                actual_result: '',
            },
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            'bold', 'italic', 'underline', { 'list': 'bullet' }, { 'list': 'ordered'},
                            'align',
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                }
            }
        }
    },
    components: {
        Icon, Loader, Link, QuillEditor, Head, draggable, DeleteConfirmation
    },
    computed: {

    },
    created() {
        this.moment = moment
        //get all test steps for selected test case
        this.getTestScript(this.test_case.id);

        //set start flag to `started` if test case is locked(test case is locked when test case is started)
        //set start flag to `completed` if execution status is PASS
        this.start = this.test_case.is_locked == 1 ? 'started' : this.test_case.execution_status === 'PASS' ? 'completed' : 'not_started';
        
        //if test case is locked start timer
        if(this.test_case.is_locked == 1) {
            this.startTimer();
        }
    },
    methods: {
        onEditorReady(editor){editor.focus();},
        execute(flag = 'start'){
            const data = {
                id: this.test_case.id,
                flag: flag
            };
            axios.post(this.route('json.test_script.execute'), data).then((response) => {
                if(response.data.status) {
                    this.start = flag == 'start' ? 'started' : 'completed';
                    if(flag == 'start') {
                        this.startTimer();
                    } else {
                        clearInterval(this.timerInterval);
                    }
                    this.$emit('getTestCase', this.test_case.id);
                    this.getTestScript(this.test_case.id);
                }
            });
        },
        retakeExecution() {
            const data = {
                id: this.test_case.id,
                flag: 'start'
            };
            axios.post(this.route('json.test_script.execute'), data).then((response) => {
                this.start = 'retake';
                this.startTimer();
                this.$emit('getTestCase', this.test_case.id);
                this.getTestScript(this.test_case.id);
            });
        },
        startTimer() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }
            this.timerInterval = setInterval(this.updateTimer, 1000);
        },
        updateTimer() {
            const startTime = this.test_case.locked_at == null ? this.timer : this.test_case.locked_at;
            const lockedTimestamp = new Date(startTime);
            const now = new Date();
            const elapsed = Math.floor((now - lockedTimestamp) / 1000);

            const hours = String(Math.floor(elapsed / 3600)).padStart(2, '0');
            const minutes = String(Math.floor((elapsed % 3600) / 60)).padStart(2, '0');
            const seconds = String(elapsed % 60).padStart(2, '0');

            this.timer = `${hours}:${minutes}:${seconds}`;
        },
        async getTestCase(id=null) {
            const testCaseResponse = await axios.get(this.route('json.test_case.get', id == null ? this.test_case.id : id));
            this.test_case = testCaseResponse.data;
        },        
        async getTestScript(id, loading = true){
            this.loading = loading;
            console.log(id)
            const testCaseResponse = await axios.get(this.route('json.test_script.get', {uid:id}));
            this.testScripts = testCaseResponse.data.map(step => {
                return {
                    ...step,
                    status_label: step.executions[0]?.status_label,
                    }
                })
            
            this.loading = false
        },    
        closeConfirm(){
            this.deleteData = {id: null, index: null, confirm: false}
        },
        toggleEditor(key, index, element) {
            this.editIndex = index;
            this.actualResultData[index] = element?.executions[0]?.actual_result;
        },
        updateStatus(element, index) {
            if(this.start == 'started' || this.start == 'retake') {
                const data = { 
                    id: element.id,
                    status: element.status_label,
                    revision: this.test_case.revision,
                    actual_result: this.actualResultData[index]
                };
                axios.post(this.route('json.test_script.update_status'), data).then((response) => {
                    if(response.data.status && response.data.completed) {
                        this.start = 'completed';
                        clearInterval(this.timerInterval);
                        this.$emit('getTestCase', this.test_case.id);
                    }
                    this.getTestScript(this.test_case.id, false);
                });
            } else {
                alert('Please start the execution first.');
            }
        },
        saveActualResult(index) {
            // Logic to save the details
            this.testScripts[index].executions = [{
                actual_result: this.actualResultData[index]
            }]; // Update the actual_result field of the corresponding element
            this.editIndex = null; // Exit the edit mode
        }
    },
    beforeDestroy() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    },
    name: "execute-test-script"
};
</script>
